import React, { useState, useEffect } from 'react';
import './PowerUpTimerBar.css';

const PowerUpTimerBar = ({ activeType, duration, isRunning }) => {
    const [displayedType, setDisplayedType] = useState(activeType);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (activeType) {
            // New powerup active: display it and ensure not exiting
            setDisplayedType(activeType);
            setIsExiting(false);
        } else if (displayedType && !activeType) {
            // Powerup finished: trigger exit animation
            setIsExiting(true);
        }
    }, [activeType, displayedType]);

    // Don't render anything if there's no powerup to show/animate
    if (!displayedType) return null;

    const handleAnimationEnd = (e) => {
        // Only remove the element when the exit animation finishes
        if (e.animationName === 'popOut' || e.animationName === 'fadeOut') {
            setDisplayedType(null);
            setIsExiting(false);
        }
    };

    return (
        <div 
            className={`powerup-bar-container ${isExiting ? 'fade-out' : ''}`}
            onAnimationEnd={handleAnimationEnd}
        >
            <div 
                className={`powerup-bar-fill ${displayedType}`}
                style={{
                    animationDuration: `${duration}s`,
                    animationPlayState: isRunning ? 'running' : 'paused'
                }}
            />
        </div>
    );
};

export default PowerUpTimerBar;